import { Form, Row, Col, Button } from "react-bootstrap";
import FilePicker from "./FilePicker";
import { toast } from "react-toastify";
import { FaRegTrashAlt } from "react-icons/fa";

const DocumentBlock = ({
  tenantId,
  center_id,
  center_uuid,
  centerLogo,
  tableName,
  tableId,
  options,
  value,
  description,
  file,
  setFile,
  onTypeChange,
  onDescChange,
  attachments = [],
  setAttachments,
}) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const STORAGE_URL = process.env.REACT_APP_PORTAL_URL;
  const storageBaseUrl = `${STORAGE_URL.replace(/\/+$/, "")}/`;

  const handleUpload = async () => {
    if (!file || !value) {
      alert("File & Type required");
      return;
    }

    try {
      const fD = new FormData();

      fD.append("file", file);
      fD.append("tenant_id", tenantId || "");
      fD.append("center_id", center_id);
      fD.append("apc_table_name", tableName);
      fD.append("apc_table_id", tableId);
      fD.append("apc_attachment_type", value);
      fD.append("apc_attachment_desc", description || "");

      const params = new URLSearchParams({ tenant_id: tenantId || "" });
      const res = await fetch(
        `${API_URL}/upload-parent-child-doc?${params.toString()}`,
        {
          method: "POST",
          body: fD,
        },
      );

      const json = await res.json();

      if (json.type) {
        const newFile = {
          id: json.data.id,
          file_name: json.data.file_name,
          attachment_type: json.data.attachment_type,
          attachment_desc: json.data.attachment_desc,
        };

        setAttachments([...(attachments || []), newFile]);

        setFile(null);
        onTypeChange({ target: { value: "" } });
        onDescChange({ target: { value: "" } });

        toast.success("Uploaded");
      } else {
        toast.error(json.message);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const handleDelete = async (id) => {
    try {
      const fD = new FormData();
      fD.append("id", id);
      fD.append("tenant_id", tenantId || "");

      const params = new URLSearchParams({ tenant_id: tenantId || "" });
      const res = await fetch(
        `${API_URL}/delete-doc?${params.toString()}`,
        {
          method: "POST",
          body: fD,
        },
      );

      const json = await res.json();

      if (json.type) {
        setAttachments(attachments.filter((item) => item.id !== id));
        toast.success("Deleted");
      } else {
        toast.error(json.message);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div>
      <Row className="mb-4">
        <Col md={3}>
          <FilePicker
            file={file}
            setFile={setFile}
            uploadable={false}
            height={200}
          />
        </Col>

        <Col md={3}>
          <Form.Select className="mb-3" value={value} onChange={onTypeChange}>
            <option value="">Select...</option>
            {options.map((opt) => {
              const isUploaded = attachments.some(
                (item) => item.attachment_type === opt.value
              );

              return (
                <option key={opt.value} value={opt.value} disabled={isUploaded}>
                  {opt.label} {isUploaded ? "(Uploaded)" : ""}
                </option>
              );
            })}
          </Form.Select>

          <Form.Control
            className="mb-3"
            placeholder="Description"
            value={description}
            onChange={onDescChange}
          />

          <Button className="w-100" onClick={handleUpload}>
            Upload
          </Button>
        </Col>
      </Row>
      <Row className="mb-4">
        {attachments?.map((item) => {
          const documentUrl = `${storageBaseUrl}${center_uuid}/attachments_parent_child/${item.file_name}`;

          return (
          <Col md={3} key={item.id} className="mb-3">
            {/* TITLE (Type) */}
            <div className=" fw-bold mb-2">
              {options.find((o) => o.value === item.attachment_type)?.label ||
                item.attachment_type}
            </div>
            <div className="border rounded p-3 position-relative ">
              {/* Delete button */}
              <button
                style={{
                  padding: 3,
                  border: 0,
                  background: "none",
                  position: "absolute",
                  top: 6,
                  right: 6,
                }}
                onClick={() => handleDelete(item.id)}
              >
                <FaRegTrashAlt style={{ color: "#dc3545" }} />
              </button>

              {/* IMAGE / PDF */}
              <div
                className="d-flex justify-content-center align-items-center mb-2"
                style={{ height: 150 }}
              >
                {item.file_name.endsWith(".pdf") ? (
                  <a
                    href={documentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-center text-decoration-none"
                  >
                    <strong>PDF</strong>
                  </a>
                ) : (
                  <a
                    href={documentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={documentUrl}
                      alt={item.attachment_type || "Document"}
                      className="img-fluid"
                      style={{
                        maxHeight: 140,
                        objectFit: "contain",
                      }}
                    />
                  </a>
                )}
              </div>
            </div>
            {/* DESCRIPTION */}
            {item.attachment_desc && (
              <div className="mt-2 text-muted small">
                {item.attachment_desc}
              </div>
            )}
          </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default DocumentBlock;
